module.exports = __webpack_public_path__ + "static/media/it-manager.df0804e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vacancies/it-manager.jpg
// module id = 360
// module chunks = 0